import styled from 'styled-components';

export const Container = styled.div`
  grid-area: title;
  display: flex;
  & h1 {
    font-size: ${(props) =>
      props.textSize ? props.textSize + 'em;' : '2.5em;'};
    padding: 0px;
    margin: 0px;
  }
`;
